import { Button, styled } from "@mui/material";

export const BglCloseButtonBase = styled(Button)(({theme}) => ({
  backgroundColor : theme.bglPalette.data_colors.error_btn,
  borderColor : theme.bglPalette.data_colors.error_btn,
  ":hover" : {
    backgroundColor : theme.bglPalette.data_colors.error_btn,
    borderColor : theme.bglPalette.data_colors.error_btn
  }
}))

export const BglPrimaryButtonBase = styled(Button)(({theme}) => ({
  backgroundColor : theme.bglPalette.data_colors.primart_btn,
  borderColor : theme.bglPalette.data_colors.primart_btn,
  ":hover" : {
    backgroundColor : theme.bglPalette.data_colors.primart_btn,
    borderColor : theme.bglPalette.data_colors.primart_btn
  }
}))

export const BglOutlinedButtonBase = styled(Button)(({theme}) => (
  {
  color : theme.bglPalette.bgl_red[500],
  borderColor : theme.bglPalette.bgl_red[500],
  ":hover" : {
    borderColor : theme.bglPalette.bgl_red[500]
  }
}))

export const BglCloseButton = (props : any) => {
  return (
    <BglCloseButtonBase
    size="large" 
    variant="contained"
    {...props}/>
  )
}

export const BglPrimaryButton = (props : any) => {
  return (
    <BglPrimaryButtonBase
    size="large" 
    variant="contained"
    {...props}/>
  )
}

export const BglOutlinedButton = (props : any) => {
  return (
    <BglOutlinedButtonBase
    size="large" 
    variant="outlined"
    {...props}/>
  )
}